import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  error: false,
  showError: false,
  message: "",
  loading: false,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    showError(state, { payload }) {
      state.error = true;
      let msg = "";

      const getMessage = (val) => {
        if (!val) return "";
        if (typeof val === "string") {
          let cleanVal = val.trim();
          if (cleanVal.startsWith("Error: ")) {
            cleanVal = cleanVal.substring(7).trim();
          }
          try {
            const parsed = JSON.parse(cleanVal);
            if (parsed && typeof parsed === "object") {
              return parsed.message || parsed.error || JSON.stringify(parsed);
            }
          } catch (e) {}
          return val;
        }
        if (typeof val === "object") {
          return val.message || val.error || JSON.stringify(val);
        }
        return String(val);
      };

      if (payload?.data) {
        msg = getMessage(payload.data);
      } else if (payload?.error?.data) {
        msg = getMessage(payload.error.data);
      } else if (payload?.error?.error) {
        msg = getMessage(payload.error.error);
      } else if (payload?.error?.message) {
        msg = getMessage(payload.error.message);
      } else {
        msg = "Something went wrong!";
      }

      state.message = msg;
      state.showError = true;
    },
    hideError(state) {
      state.error = false;
      state.message = "";
      state.showError = false;
    },
  },
});

export const { showError, hideError } = loadingSlice.actions;
export default loadingSlice.reducer;
